export enum ErrorOriginEnum {
  BACKEND = "BACKEND",
  FRONTEND = "FRONTEND",
}

export enum ObjectAssignedEnum {
  PRODUCTLINE = "PRODUCTLINE",

  PROPERTY = "PROPERTY",
  PROPERTYVALUE = "PROPERTYVALUE",
  VALUEATTRCELL = "VALUEATTRCELL",

  RULETABLE = "RULETABLE",
  RULETABLEROW = "RULETABLEROW",
  RULETABLECELL = "RULETABLECELL",

  LOGICGROUP = "LOGICGROUP",
}

export enum ValidatorNames {
  WrongDomainForBoolean = "WrongDomainForBoolean",
  WrongDataTypeForRange = "WrongDataTypeForRange",
  WrongRulesetsInRuleTableProperties = "WrongRulesetsInRuleTableProperties",
}

export enum ValidationTypes {
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
}

// export interface ErrorObject {
//   id: string;
//   objectInfo: any;
//   productLineId: string;
//   type: ValidationTypes;
//   origin: ErrorOriginEnum;
//   objectAssigned: ObjectAssignedEnum;
//   objectId: string;
//   validatorName: ValidatorNames;
//   message: string | null;
//   relatedObjects: any[];
//   createdAt: string;
// }

export interface ValidationById {
  [key: string]: ValidationResponse;
}

export interface ValidationState {
  byId: ValidationById;
  allIds: string[];
  getting: boolean;
  deleting: boolean;
  posting: boolean;
}

export interface Validation {
  id: string;
  productLineId: string;
  type: ValidationTypes;
  origin: ErrorOriginEnum;
  objectAssigned: ObjectAssignedEnum;
  objectId: string;
  validatorName: string;
  message: string | null;
  relatedObjects: ValidationRelatedObject[];
  createdAt?: string;
  dbSchemaVersion?: number;
}

export interface ValidationResponse extends Validation {
  objectInfo: Record<string, any>;
}

export interface ValidationRelatedObject {
  objectAssigned: string;
  objectId: string;
}

export interface ValidationQueryParams {
  type?: string;
  origin?: string;
  objectAssigned?: string;
  objectId?: string;
}

/** Catalog metadata for a registered backend validator (IValidator minus Execute). */
export interface ValidatorInfo {
  name: string;
  displayName: string;
  description: string;
  canDisable: boolean;
  contexts: Array<string | number>;
}

export interface ValidationSettingsResponse {
  validators: ValidatorInfo[];
  disabledValidatorNames: string[];
}

export interface UpdateValidationSettingsRequest {
  disabledValidatorNames: string[];
}
